export const HOME = "/"
export const SIGNIN ="/sign-in";
export const SIGNUP ="/sign-up";    
export const BROWSE = "/browse";